import DispenseCash from './DispenseCash.jsx';

export default DispenseCash;